import {
	reOrgConstructionMaterialConstants
}from "./constants"
import actions from '../../actions'

const initialState =
{
	isSending      : false,
	isAuditSending : false,
	paged          : {},
	pagedAudit     : {},
	changed        : null,
	list           : []
}

export default function (state = initialState, action){
	switch (action.type){
		case reOrgConstructionMaterialConstants.GetPaged.REQUEST:
		case reOrgConstructionMaterialConstants.GetPagedAll.REQUEST:
		case reOrgConstructionMaterialConstants.GetReOrgList.REQUEST:
		case reOrgConstructionMaterialConstants.Create.REQUEST:
		case reOrgConstructionMaterialConstants.Delete.REQUEST:
		case reOrgConstructionMaterialConstants.DeleteSelected.REQUEST:
		case reOrgConstructionMaterialConstants.DeleteByFilter.REQUEST:
		case reOrgConstructionMaterialConstants.Restore.REQUEST:
		case reOrgConstructionMaterialConstants.Update.REQUEST:
		case reOrgConstructionMaterialConstants.CreateFromFile.REQUEST:
		case reOrgConstructionMaterialConstants.GetExampleFile.REQUEST:
		case reOrgConstructionMaterialConstants.GetDuplicateNamesFile.REQUEST:
		case reOrgConstructionMaterialConstants.RemoveDuplicateNames.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reOrgConstructionMaterialConstants.GetPaged.FAILURE:
		case reOrgConstructionMaterialConstants.GetPagedAll.FAILURE:
		case reOrgConstructionMaterialConstants.GetReOrgList.FAILURE:
		case reOrgConstructionMaterialConstants.Create.FAILURE:
		case reOrgConstructionMaterialConstants.Delete.FAILURE:
		case reOrgConstructionMaterialConstants.DeleteSelected.FAILURE:
		case reOrgConstructionMaterialConstants.DeleteByFilter.FAILURE:
		case reOrgConstructionMaterialConstants.Restore.FAILURE:
		case reOrgConstructionMaterialConstants.Update.FAILURE:
		case reOrgConstructionMaterialConstants.CreateFromFile.FAILURE:
		case reOrgConstructionMaterialConstants.GetExampleFile.FAILURE:
		case reOrgConstructionMaterialConstants.GetDuplicateNamesFile.FAILURE:
		case reOrgConstructionMaterialConstants.RemoveDuplicateNames.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reOrgConstructionMaterialConstants.GetPagedAudit.REQUEST:
			return {
				...state,
				isAuditSending: true
			}
		case reOrgConstructionMaterialConstants.GetPagedAudit.FAILURE:
			return {
				...state,
				isAuditSending: false
			}
		case reOrgConstructionMaterialConstants.GetPagedAudit.CLEAR:
			return {
				...state,
				pagedAudit     : null,
				isAuditSending : false
			}
		case reOrgConstructionMaterialConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isAuditSending : false,
				pagedAudit     : action.payload.result
			}
		case reOrgConstructionMaterialConstants.GetPaged.SUCCESS:
		case reOrgConstructionMaterialConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reOrgConstructionMaterialConstants.GetExampleFile.SUCCESS:
		case reOrgConstructionMaterialConstants.GetDuplicateNamesFile.SUCCESS:
			return {
				...state,
				isSending: false
			}
		case reOrgConstructionMaterialConstants.GetReOrgList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reOrgConstructionMaterialConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reOrgConstructionMaterialConstants.RemoveDuplicateNames.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? "Дубликаты удалены." : null
			}
		case reOrgConstructionMaterialConstants.CreateFromFile.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.download : null
			}
		case reOrgConstructionMaterialConstants.DeleteSelected.SUCCESS:
		case reOrgConstructionMaterialConstants.DeleteByFilter.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reOrgConstructionMaterialConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result
			}
		case reOrgConstructionMaterialConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reOrgConstructionMaterialConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reOrgConstructionMaterialConstants.CLEAR:
			return {
				...state,
				changed        : null,
				isSending      : false,
				isAuditSending : false,
				paged          : {},
				pagedAudit     : {},
				list           : []
			}
		default:
			return state
	}
}